import React from 'react';
import {startBrandConfig} from './shared/brand/brandStore';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { GoogleBridgePage } from './features/auth/GoogleBridgePage';
import { AppProviders } from './app/AppProviders';
import './styles/global.css';
import './styles/auth-legacy.css';
import './styles/lobby-legacy.css';
import './styles/room-legacy.css';
import './styles/wallet-legacy.css';
import './styles/me-legacy.css';
import './styles/room-overlays-legacy.css';
import './styles/round-result.css';
import './styles/rules-legacy.css';
import './styles/rules-milhar.css';
import './styles/ds-tokens.css';
import './styles/ds-components.css';
import './styles/deposit-sheet-v2.css';
import './styles/faq.css';
import './styles/lobby-next.css';
import { preloadLanguage, useI18nStore } from './shared/i18n/i18nStore';
import { normalizeLanguage } from './shared/i18n/messages';
import { googleReturnLocale } from './features/auth/googleBridge';
import { exposeDevStores } from './shared/devStores';
import { activeCountry } from './shared/country/countryStore';
import { setCountryProvider } from './shared/lib/format';
import { captureDeliveryAttribution } from './shared/lib/attribution';

// The money formatters take a country but default to whatever this returns, which
// is how ~195 call sites stay free of a country argument. Injected here rather than
// imported inside format.ts so that module stays a dependency-free leaf.
setCountryProvider(activeCountry);

// Dev only, and dropped from production bundles. Makes `window.__sorteia` the
// reliable way to read app state — a console `import()` gets a duplicate module
// instance under Vite and reports stale values. See shared/devStores.ts.
exposeDevStores();
const googleBridgePage = ['/auth/google', '/auth/google/return'].includes(window.location.pathname);
if (googleBridgePage) {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const locale = window.location.pathname === '/auth/google/return'
    ? googleReturnLocale(params.get('state') || '') : params.get('locale');
  if (locale) useI18nStore.getState().setLanguage(normalizeLanguage(locale));
}
if (!googleBridgePage) {
  startBrandConfig();
  void captureDeliveryAttribution();
}

// Only pt-BR ships in the entry chunk; en and es are separate. Resolving the
// persisted locale before the first render is what stops an en/es user seeing
// a frame of Portuguese on every cold load. For pt-BR this settles immediately
// and adds no request, so the common path is unchanged. The static skeleton in
// index.html is on screen throughout either way.
void preloadLanguage().finally(() => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <AppProviders>
        {googleBridgePage ? <GoogleBridgePage /> : <App />}
      </AppProviders>
    </React.StrictMode>,
  );
});
